module.exports = __webpack_public_path__ + "static/media/bus_ticket.c308a12e.png";